//# sourceMappingURL=automations.mjs.map
/// <reference types="./automations.d.mts" />
import * as $endpoints from "../../../altar/altar/endpoints.mjs";
import * as $when from "../../../altar/altar/when.mjs";
import * as $admin_automations from "../../../data_types/data/admin_automations.mjs";
import * as $ai_metrics from "../../../data_types/data/ai_metrics.mjs";
import * as $connector from "../../../data_types/data/connector.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $callout from "../../../ds/ds/components/callout.mjs";
import * as $input from "../../../ds/ds/components/input.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $toggler from "../../../ds/ds/components/toggler.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $events from "../../../ds/ds/events.mjs";
import * as $utils from "../../../ds/ds/utils.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $set from "../../../gleam_stdlib/gleam/set.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../../gleam_stdlib/gleam/uri.mjs";
import * as $window from "../../../magellan/magellan/window.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $sh from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $uuid from "../../../youid/youid/uuid.mjs";
import * as $automations_effects from "../../admin/effects/automations.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $card from "../../components/card.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList, CustomType as $CustomType, makeError } from "../../gleam.mjs";
import * as $common from "../../view/common.mjs";
import * as $s from "../../view/organization/ai_search_styles.mjs";

const FILEPATH = "src/view/organization/automations.gleam";

class ProposalModalProps extends $CustomType {
  constructor(modal, proposal_id, config) {
    super();
    this.modal = modal;
    this.proposal_id = proposal_id;
    this.config = config;
  }
}

function open_connector_popup(connector, access_token) {
  let connector$1 = $connector.to_string(connector);
  let $ = $uri.parse($endpoints.loki());
  let uri;
  if ($ instanceof Ok) {
    uri = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "view/organization/automations",
      491,
      "open_connector_popup",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 17057,
        end: 17105,
        pattern_start: 17068,
        pattern_end: 17075
      }
    )
  }
  let _block;
  let _pipe = $uri.query_to_string(
    toList([["access_token", access_token], ["connector", connector$1]]),
  );
  _block = new $option.Some(_pipe);
  let query = _block;
  let _block$1;
  let _pipe$1 = new $uri.Uri(
    uri.scheme,
    uri.userinfo,
    uri.host,
    uri.port,
    uri.path + "/authorize",
    query,
    uri.fragment,
  );
  _block$1 = $uri.to_string(_pipe$1);
  let uri$1 = _block$1;
  let $1 = [400, 600];
  let width = $1[0];
  let height = $1[1];
  let win = $window.self();
  let left = $window.screen_x(win) + (globalThis.Math.trunc(
    ($window.inner_width(win) - width) / 2
  ));
  let top = $window.screen_y(win) + (globalThis.Math.trunc(
    ($window.inner_height(win) - height) / 2
  ));
  let _pipe$2 = toList([
    "popup",
    "height=" + $int.to_string(height),
    "width=" + $int.to_string(width),
    "left=" + $int.to_string(left),
    "top=" + $int.to_string(top),
  ]);
  let _pipe$3 = $string.join(_pipe$2, ",");
  return ((_capture) => {
    return $window.open(uri$1, "steerlab:connectors:authorize:popup", _capture);
  })(_pipe$3);
}

function google_token(store) {
  let connector = new $connector.GoogleDrive();
  return $s.card(
    toList([]),
    toList([
      $s.card_title(toList([]), toList([$h.text("Enter proposal_id")])),
      $button.links.primary(
        toList([
          $e.on_click(
            (_) => {
              $middleware.require_access_token(
                store.client,
                (access_token) => {
                  let $ = open_connector_popup(connector, access_token);
                  
                  return $promise.resolve(undefined);
                },
              );
              return undefined;
            },
          ),
        ]),
        toList([$h.text("Connect to drive")]),
      ),
    ]),
  );
}

function select_proposal_id(proposal_id, set_proposal_id) {
  return $card.card(
    toList([]),
    toList([
      $card.title(toList([]), toList([$h.text("Enter proposal_id")])),
      $card.body(
        toList([]),
        toList([
          $h.text("For the actions below, you need to enter a proposal ID. "),
          $h.text(
            "As they run on a selected proposal, you need to enter its ID. ",
          ),
          $h.text("The only allowed format is an UUID."),
        ]),
      ),
      $card.footer(
        toList([]),
        toList([
          $input.input(
            (() => {
              let _pipe = $input.value(proposal_id);
              return $input.on_input(
                _pipe,
                (input) => {
                  return $bool.lazy_guard(
                    input === "",
                    () => { return set_proposal_id(""); },
                    () => {
                      let $ = $uuid.from_string(input);
                      if ($ instanceof Ok) {
                        let input$1 = $[0];
                        return set_proposal_id($uuid.to_string(input$1));
                      } else {
                        return undefined;
                      }
                    },
                  );
                },
              );
            })(),
          ),
        ]),
      ),
    ]),
  );
}

function dry_run_unsafe() {
  return $callout.warning(
    toList([]),
    toList([
      $callout.header(
        toList([]),
        toList([$h.text("Dry Run "), $common.bold("deactivated")]),
      ),
      $callout.content(
        toList([$a.style(toList([["display", "block"]]))]),
        toList([
          $h.text("Be careful when running your automations, as changes "),
          $h.text("will be persisted on backend."),
        ]),
      ),
    ]),
  );
}

function dry_run_safe() {
  return $callout.success(
    toList([]),
    toList([
      $callout.header(toList([]), toList([$h.text("Dry Run Activated")])),
      $callout.content(
        toList([]),
        toList([
          $h.text("Your changes will not be persisted, "),
          $h.text("nothing harmful can be done on backend."),
        ]),
      ),
    ]),
  );
}

function dry_run_card(dry_run, set_dry_run) {
  return $card.card(
    toList([]),
    toList([
      $card.title(
        toList([]),
        toList([
          $l.row(
            toList([$l.align("center"), $l.gap(9), $l.justify("space-between")]),
            toList([]),
            toList([
              $h.text("Dry Run"),
              $toggler.toggler(
                toList([
                  $toggler.active(dry_run),
                  $toggler.on_change(set_dry_run),
                ]),
              ),
            ]),
          ),
        ]),
      ),
      $card.body(
        toList([]),
        toList([
          $h.text("When activating dry run, every automation will run, "),
          $h.text(
            "but won't save changes. Use it to test your automations, or ",
          ),
          $h.text(
            "to check that every runs correctly before persisting changes.",
          ),
        ]),
      ),
      $card.footer(
        toList([$a.style(toList([["margin-bottom", "6px"]]))]),
        toList([
          (() => {
            if (dry_run) {
              return dry_run_safe();
            } else {
              return dry_run_unsafe();
            }
          })(),
        ]),
      ),
    ]),
  );
}

function use_modal_click(confirm, handler) {
  let modal = $modal.use_modal();
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => {
    return $redraw.use_callback(_capture, [confirm, handler]);
  })(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          let return$ = modal.open(confirm);
          return $promise.map(
            return$,
            (return$) => {
              return $result.map(
                return$,
                (org_id) => { return dispatch(handler(org_id)); },
              );
            },
          );
        },
      );
    },
  );
}

function confirm_trigger_digest() {
  return $redraw.component_(
    "ConfirmTriggerDigest",
    (props) => {
      let store = $store.use_state();
      return $when.some(
        store.organization,
        (org_id) => {
          let org_name = $store.organization_name_from_id(store, org_id);
          let on_cancel = $e.on_click(
            (_) => { return props.on_end(new Error(undefined)); },
          );
          let on_confirm = $e.on_click(
            (_) => { return props.on_end(new Ok(org_id)); },
          );
          return $modal.modal(
            toList([]),
            toList([
              $modal.body(
                toList([$utils.stop_propagation()]),
                toList([
                  $modal.title(
                    toList([]),
                    toList([
                      $h.text(
                        "Are you sure you want to trigger the Slack digest for ",
                      ),
                      $h.text(org_name),
                      $h.text((" (" + org_id) + ") ?"),
                    ]),
                  ),
                  $modal.explanations(
                    toList([]),
                    toList([
                      $h.text(
                        "The digest job will run for this organization only, as the ",
                      ),
                      $h.text(
                        "hourly cron does. Only users whose digest day and hour ",
                      ),
                      $h.text(
                        "match the current time will receive a Slack message.",
                      ),
                    ]),
                  ),
                  $modal.actions(
                    toList([]),
                    toList([
                      $button.primary(
                        toList([on_cancel]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.secondary(
                        toList([on_confirm]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function trigger_digest() {
  return $redraw.compose(
    confirm_trigger_digest(),
    (confirm) => {
      return $redraw.component_(
        "TriggerDigest",
        (_) => {
          let store = $store.use_state();
          let on_click = use_modal_click(
            confirm,
            (_) => { return $automations_effects.trigger_digest(); },
          );
          let disabled = $option.is_none(store.organization);
          return $card.card(
            toList([]),
            toList([
              $card.title(toList([]), toList([$h.text("Trigger Digest")])),
              $card.body(
                toList([]),
                toList([
                  $h.text(
                    "This action runs the Slack weekly digest job immediately for ",
                  ),
                  $h.text("the selected organization, as the hourly cron does."),
                ]),
              ),
              $card.footer(
                toList([]),
                toList([
                  $callout.info(
                    toList([]),
                    toList([
                      $callout.content(
                        toList([]),
                        toList([
                          $h.text(
                            "Users' digest day and hour preferences are still ",
                          ),
                          $h.text(
                            "honoured: only users whose configured slot matches the ",
                          ),
                          $h.text("current time will receive a message."),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              ),
              $l.row(
                toList([
                  $l.justify("end"),
                  $l.styles(toList([$css.margin_top_("9px")])),
                ]),
                toList([]),
                toList([
                  $button.primary(
                    toList([$a.disabled(disabled), $e.on_click(on_click)]),
                    toList([$h.text("Trigger digest")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function unlock_sheet_card() {
  return $redraw.component_(
    "UnlockSheetCard",
    (_) => {
      let dispatch = $store.use_effect_dispatch();
      return $card.card(
        toList([]),
        toList([
          $card.title(toList([]), toList([$h.text("Unlock Sheet")])),
          $card.body(
            toList([]),
            toList([
              $h.text("Upload a password-protected Excel sheet to remove its "),
              $h.text(
                "protection. The unlocked file will be downloaded automatically.",
              ),
            ]),
          ),
          $l.row(
            toList([
              $l.justify("end"),
              $l.styles(toList([$css.margin_top_("9px")])),
            ]),
            toList([]),
            toList([
              $l.column(
                toList([$l.tag("label")]),
                toList([]),
                toList([
                  $sh.div(
                    $button.classes.primary(),
                    toList([]),
                    toList([$h.text("Upload sheet")]),
                  ),
                  $h.input(
                    toList([
                      $a.type_("file"),
                      $a.style(toList([["display", "none"]])),
                      $a.accept(toList([".xlsx"])),
                      $events.on_files_change(
                        (files) => {
                          let $ = $list.first(files);
                          if ($ instanceof Ok) {
                            let f = $[0];
                            dispatch($automations_effects.unlock_sheet(f));
                            return undefined;
                          } else {
                            return undefined;
                          }
                        },
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function on_export(dispatch, org_id, export_type) {
  return $e.on_click(
    (_) => {
      let _pipe = export_type;
      let _pipe$1 = $automations_effects.export_content_library(_pipe, org_id);
      dispatch(_pipe$1);
      return undefined;
    },
  );
}

function export_content_library_buttons() {
  return $redraw.component_(
    "ExportContentLibraryButtons",
    (_) => {
      let store = $store.use_state();
      let dispatch = $store.use_effect_dispatch();
      return $when.some(
        store.organization,
        (org_id) => {
          let on_export$1 = (_capture) => {
            return on_export(dispatch, org_id, _capture);
          };
          return $card.card(
            toList([]),
            toList([
              $card.title(toList([]), toList([$h.text("Export Question Bank")])),
              $card.body(
                toList([]),
                toList([
                  $h.text(
                    "This action will make you download the entirety of the ",
                  ),
                  $h.text("organization question bank as a CSV."),
                ]),
              ),
              $card.footer(
                toList([]),
                toList([
                  $callout.info(
                    toList([]),
                    toList([
                      $callout.content(
                        toList([]),
                        toList([
                          $h.text(
                            "Depending on the size of the question bank, the resulting ",
                          ),
                          $h.text(
                            "CSV can be quite large. Please wait a little while before ",
                          ),
                          $h.text("asking why it's not working on Slack."),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              ),
              $l.row(
                toList([
                  $l.justify("end"),
                  $l.styles(toList([$css.margin_top_("9px")])),
                ]),
                toList([]),
                toList([
                  $button.primary(
                    toList([on_export$1(new $admin_automations.QuestionBank())]),
                    toList([$h.text("Export question bank")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function confirm_sync_pg_and_weaviate() {
  return $redraw.component_(
    "ConfirmSyncPgWeaviate",
    (props) => {
      let store = $store.use_state();
      return $when.some(
        store.organization,
        (org_id) => {
          let org_name = $store.organization_name_from_id(store, org_id);
          let on_cancel = $e.on_click(
            (_) => { return props.on_end(new Error(undefined)); },
          );
          let on_confirm = $e.on_click(
            (_) => { return props.on_end(new Ok(org_id)); },
          );
          return $modal.modal(
            toList([]),
            toList([
              $modal.body(
                toList([$utils.stop_propagation()]),
                toList([
                  $modal.title(
                    toList([]),
                    toList([
                      $h.text(
                        "Are you sure you want to sync the data between PG ",
                      ),
                      $h.text("and Weaviate for " + org_name),
                      $h.text(("(" + org_id) + ") ?"),
                    ]),
                  ),
                  $modal.explanations(
                    toList([]),
                    toList([
                      $h.text(
                        "This will go through all the data sources in the database ",
                      ),
                      $h.text(
                        "ensure weaviate is aligned with PG, and will go through all ",
                      ),
                      $h.text(
                        "weaviate and remove elements that are not in the PG.",
                      ),
                    ]),
                  ),
                  $modal.actions(
                    toList([]),
                    toList([
                      $button.primary(
                        toList([on_cancel]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.secondary(
                        toList([on_confirm]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function sync_pg_and_weaviate() {
  return $redraw.compose(
    confirm_sync_pg_and_weaviate(),
    (confirm) => {
      return $redraw.component_(
        "SyncPgWeaviate",
        (_use0) => {
          let dry_run = _use0[0];
          let $ = $redraw.use_state(false);
          let reingest = $[0];
          let set_reingest = $[1];
          let store = $store.use_state();
          let handler = (_capture) => {
            return $automations_effects.sync_pg_and_weaviate(
              _capture,
              reingest,
              dry_run,
            );
          };
          let on_click = use_modal_click(confirm, handler);
          let disabled = $option.is_none(store.organization);
          return $card.card(
            toList([]),
            toList([
              $card.title(toList([]), toList([$h.text("Synchronise Data")])),
              $card.body(
                toList([]),
                toList([
                  $h.text(
                    "This action will correct Weaviate data, and ensure it's ",
                  ),
                  $h.text(
                    "properly synced with PG. If you check \"Reingest\", all data ",
                  ),
                  $h.text("will also be reingested before synced."),
                ]),
              ),
              $l.column(
                toList([$l.gap(8)]),
                toList([]),
                toList([
                  $l.row(
                    toList([$l.gap(8), $l.align("center"), $l.justify("end")]),
                    toList([]),
                    toList([
                      $typography.text(
                        $typography.sm,
                        $typography.medium,
                        "Reingest",
                      ),
                      $toggler.toggler(
                        toList([
                          $toggler.active(reingest),
                          $toggler.on_change(set_reingest),
                        ]),
                      ),
                    ]),
                  ),
                  $l.row(
                    toList([$l.gap(8), $l.align("center"), $l.justify("end")]),
                    toList([]),
                    toList([
                      $button.primary(
                        toList([$a.disabled(disabled), $e.on_click(on_click)]),
                        toList([$h.text("Sync PG and weaviate")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function confirm_reingest_data() {
  return $redraw.component_(
    "ConfirmReingestData",
    (props) => {
      let store = $store.use_state();
      return $when.some(
        store.organization,
        (org_id) => {
          let on_cancel = $e.on_click(
            (_) => { return props.on_end(new Error(undefined)); },
          );
          let on_confirm = $e.on_click(
            (_) => { return props.on_end(new Ok(org_id)); },
          );
          return $modal.modal(
            toList([]),
            toList([
              $modal.body(
                toList([$utils.stop_propagation()]),
                toList([
                  $modal.title(
                    toList([]),
                    toList([
                      $h.text("Are you sure you want to reingest the data "),
                      $h.text(("for " + org_id) + "?"),
                    ]),
                  ),
                  $modal.explanations(
                    toList([]),
                    toList([
                      $h.text(
                        "This will go through all the data sources in the database, ",
                      ),
                      $h.text(
                        "create messages of ingestion, upgrade all versions and ",
                      ),
                      $h.text("update the weaviate."),
                    ]),
                  ),
                  $modal.actions(
                    toList([]),
                    toList([
                      $button.primary(
                        toList([on_cancel]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.secondary(
                        toList([on_confirm]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function reingest_data() {
  return $redraw.compose(
    confirm_reingest_data(),
    (confirm) => {
      return $redraw.component_(
        "ReingestData",
        (_) => {
          let store = $store.use_state();
          let on_click = use_modal_click(
            confirm,
            $automations_effects.reingest_data,
          );
          let disabled = $option.is_none(store.organization);
          return $card.card(
            toList([]),
            toList([
              $card.title(toList([]), toList([$h.text("Re-ingest Data")])),
              $card.body(
                toList([]),
                toList([
                  $h.text(
                    "This action re-ingest and upgrade the version of all data ",
                  ),
                  $h.text("both in PG and Weaviate."),
                ]),
              ),
              $card.footer(
                toList([]),
                toList([
                  $callout.warning(
                    toList([]),
                    toList([
                      $callout.header(
                        toList([]),
                        toList([$h.text("Dry run is not used in this action!")]),
                      ),
                      $callout.content(
                        toList([]),
                        toList([
                          $h.text("Be careful! "),
                          $h.text(
                            "Re-running the insights for this organization ",
                          ),
                          $h.text("will squash the data."),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              ),
              $l.row(
                toList([
                  $l.justify("end"),
                  $l.styles(toList([$css.margin_top_("9px")])),
                ]),
                toList([]),
                toList([
                  $button.primary(
                    toList([$a.disabled(disabled), $e.on_click(on_click)]),
                    toList([$h.text("Re-ingest data")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function confirm_rerun_insights() {
  return $redraw.component_(
    "ConfirmRerunInsights",
    (props) => {
      let store = $store.use_state();
      return $when.some(
        store.organization,
        (org_id) => {
          let org_name = $store.organization_name_from_id(store, org_id);
          let on_cancel = $e.on_click(
            (_) => { return props.on_end(new Error(undefined)); },
          );
          let on_confirm = $e.on_click(
            (_) => { return props.on_end(new Ok(org_id)); },
          );
          return $modal.modal(
            toList([]),
            toList([
              $modal.body(
                toList([$utils.stop_propagation()]),
                toList([
                  $modal.title(
                    toList([]),
                    toList([
                      $h.text(
                        "Are you sure you want to rerun the insights for ",
                      ),
                      $h.text(org_name),
                      $h.text((" (" + org_id) + ") ?"),
                    ]),
                  ),
                  $modal.explanations(
                    toList([]),
                    toList([
                      $h.text(
                        "Make sure that if you've already ran this action, ",
                      ),
                      $h.text(
                        "it is completed. Also, it would be preferable not to ",
                      ),
                      $h.text(
                        "upload sources in the Content Library during the process.",
                      ),
                    ]),
                  ),
                  $modal.actions(
                    toList([]),
                    toList([
                      $button.primary(
                        toList([on_cancel]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.secondary(
                        toList([on_confirm]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function rerun_insights() {
  return $redraw.compose(
    confirm_rerun_insights(),
    (confirm) => {
      return $redraw.component_(
        "RerunInsights",
        (_) => {
          let store = $store.use_state();
          let on_click = use_modal_click(
            confirm,
            $automations_effects.rerun_insights,
          );
          let disabled = $option.is_none(store.organization);
          return $card.card(
            toList([]),
            toList([
              $card.title(toList([]), toList([$h.text("Re-run Insights")])),
              $card.body(
                toList([]),
                toList([
                  $h.text(
                    "This action re-run the computation of all insights for the ",
                  ),
                  $h.text("organization."),
                ]),
              ),
              $card.footer(
                toList([]),
                toList([
                  $callout.warning(
                    toList([]),
                    toList([
                      $callout.header(
                        toList([]),
                        toList([$h.text("Dry run is not used in this action!")]),
                      ),
                      $callout.content(
                        toList([]),
                        toList([
                          $h.text("Be careful! "),
                          $h.text(
                            "Re-running the insights for this organization ",
                          ),
                          $h.text("will squash the existing insights."),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              ),
              $l.row(
                toList([
                  $l.justify("end"),
                  $l.styles(toList([$css.margin_top_("9px")])),
                ]),
                toList([]),
                toList([
                  $button.primary(
                    toList([$a.disabled(disabled), $e.on_click(on_click)]),
                    toList([$h.text("Re-run insights")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function on_select_metric_click(metric, set_metrics, _) {
  return set_metrics(
    (metrics) => {
      let $ = $set.contains(metrics, metric);
      if ($) {
        return $set.delete$(metrics, metric);
      } else {
        return $set.insert(metrics, metric);
      }
    },
  );
}

function select_metric_button(metric, metrics, set_metrics) {
  let on_click = (_capture) => {
    return on_select_metric_click(metric, set_metrics, _capture);
  };
  let attrs = toList([$button.attributes.small(), $e.on_click(on_click)]);
  let children = toList([$h.text($ai_metrics.to_string(metric))]);
  let $ = $set.contains(metrics, metric);
  if ($) {
    return $button.primary(attrs, children);
  } else {
    return $button.secondary(attrs, children);
  }
}

function confirm_proposal_metrics() {
  return $redraw.component_(
    "ConfirmProposalMetrics",
    (props) => {
      let store = $store.use_state();
      return $when.some(
        store.organization,
        (org_id) => {
          let on_cancel = $e.on_click(
            (_) => { return props.modal.on_end(new Error(undefined)); },
          );
          let on_confirm = $e.on_click(
            (_) => { return props.modal.on_end(new Ok(org_id)); },
          );
          return $modal.modal(
            toList([]),
            toList([
              $modal.body(
                toList([$utils.stop_propagation()]),
                toList([
                  $modal.title(
                    toList([]),
                    toList([
                      $h.text(
                        "Are you sure you want to compute proposal metrics?",
                      ),
                    ]),
                  ),
                  $modal.explanations(
                    toList([]),
                    toList([
                      $h.text("This will export the evaluation of "),
                      $h.text(props.proposal_id),
                      $h.text(
                        " in the s3 bucket {env}-steerlab-data-ml-analytics.",
                      ),
                    ]),
                  ),
                  $modal.actions(
                    toList([]),
                    toList([
                      $button.primary(
                        toList([on_cancel]),
                        toList([$h.text("Cancel")]),
                      ),
                      $button.secondary(
                        toList([on_confirm]),
                        toList([$h.text("Submit")]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function proposal_metrics() {
  return $redraw.compose(
    confirm_proposal_metrics(),
    (confirm) => {
      return $redraw.component_(
        "ProposalMetrics",
        (_use0) => {
          let proposal_id = _use0[0];
          let store = $store.use_state();
          let $ = $redraw.use_state_($set.new$());
          let metrics = $[0];
          let set_metrics = $[1];
          let no_metrics = $set.is_empty(metrics);
          let on_click = use_modal_click(
            (m) => {
              return confirm(new ProposalModalProps(m, proposal_id, ""));
            },
            ((_capture) => {
              return $automations_effects.compute_proposal_metrics(
                _capture,
                metrics,
                proposal_id,
              );
            }),
          );
          let disabled = $option.is_none(store.organization);
          let is_proposal_id = proposal_id === "";
          let disabled$1 = (is_proposal_id || no_metrics) || disabled;
          return $card.card(
            toList([]),
            toList([
              $card.title(toList([]), toList([$h.text("Compute metrics")])),
              $card.body(
                toList([]),
                toList([
                  $h.text(
                    "This action will compute RAGAS matrics on the selected ",
                  ),
                  $h.text(
                    "proposal. You can select the specific metrics you need. ",
                  ),
                  $h.text("You need to select at least one."),
                ]),
              ),
              $h.div(
                toList([$a.style(toList([["height", "12px"]]))]),
                toList([]),
              ),
              $l.row(
                toList([
                  $l.gap(8),
                  $l.align("center"),
                  $l.justify("end"),
                  $l.wrap("wrap"),
                ]),
                toList([]),
                $list.map(
                  $ai_metrics.all_metrics,
                  (metric) => {
                    return select_metric_button(metric, metrics, set_metrics);
                  },
                ),
              ),
              $l.row(
                toList([
                  $l.justify("end"),
                  $l.styles(toList([$css.margin_top_("9px")])),
                ]),
                toList([]),
                toList([
                  $button.primary(
                    toList([$a.disabled(disabled$1), $e.on_click(on_click)]),
                    toList([$h.text("Get proposal metrics")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    proposal_metrics(),
    (proposal_metrics) => {
      return $redraw.compose(
        rerun_insights(),
        (rerun_insights) => {
          return $redraw.compose(
            reingest_data(),
            (reingest_data) => {
              return $redraw.compose(
                sync_pg_and_weaviate(),
                (sync_pg_and_weaviate) => {
                  return $redraw.compose(
                    export_content_library_buttons(),
                    (export_content_library_buttons) => {
                      return $redraw.compose(
                        unlock_sheet_card(),
                        (unlock_sheet_card) => {
                          return $redraw.compose(
                            trigger_digest(),
                            (trigger_digest) => {
                              return $redraw.component_(
                                "Automations",
                                (_) => {
                                  let $ = $redraw.use_state(true);
                                  let dry_run = $[0];
                                  let set_dry_run = $[1];
                                  let $1 = $redraw.use_state("");
                                  let proposal_id = $1[0];
                                  let set_proposal_id = $1[1];
                                  let store = $store.use_state();
                                  return $l.column(
                                    toList([$l.gap(12)]),
                                    toList([]),
                                    toList([
                                      $common.page_title("Automations"),
                                      dry_run_card(dry_run, set_dry_run),
                                      $h.div(toList([]), toList([])),
                                      $l.row(
                                        toList([$l.wrap("wrap"), $l.gap(12)]),
                                        toList([]),
                                        toList([
                                          rerun_insights(undefined),
                                          reingest_data(undefined),
                                          sync_pg_and_weaviate([dry_run]),
                                          export_content_library_buttons(
                                            undefined,
                                          ),
                                          unlock_sheet_card(undefined),
                                          trigger_digest(undefined),
                                        ]),
                                      ),
                                      $h.div(
                                        toList([
                                          $a.style(toList([["height", "12px"]])),
                                        ]),
                                        toList([]),
                                      ),
                                      select_proposal_id(
                                        proposal_id,
                                        set_proposal_id,
                                      ),
                                      $h.div(toList([]), toList([])),
                                      $l.row(
                                        toList([$l.wrap("wrap"), $l.gap(12)]),
                                        toList([]),
                                        toList([proposal_metrics([proposal_id])]),
                                      ),
                                      google_token(store),
                                    ]),
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
